// oxlint-disable-next-line no-restricted-imports
import { useMedplumProfile } from '@medplum/react-hooks'
import { invariant } from '@seen/core/invariant'
import { ExtendedPractitioner } from '@seen/core/models/practitioner'
import { useMemo } from 'react'
import { useRead } from '#src/hooks/useRead.ts'

export function useCurrentPractitioner(): ExtendedPractitioner {
  const profile = useMedplumProfile()
  invariant(
    profile,
    'Profile is not available. Component must be used when logged in'
  )
  invariant(
    profile.resourceType === 'Practitioner',
    `Profile is not a practitioner and has type ${profile.resourceType}`
  )

  // Ensure reactivity to remote changes to the currently authenticated practitioner
  const { data: practitioner } = useRead(ExtendedPractitioner, profile.id)

  return useMemo(
    () => practitioner ?? ExtendedPractitioner.fromFhirResource(profile),
    [practitioner, profile]
  )
}
